import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { ServiceState } from './service.state';

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'service', resettable: true, idKey: '_id'})
export class ServiceStore extends EntityStore<ServiceState> {
  constructor() {
    super() ;
  }
}
